import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

import { ZefFormBase, ZefFormsModule } from '@vshosting/core';
import { WarmCacheFormState } from './warm-cache-form.model';

@Component({
    selector: 'vshcdn-warm-cache-form',
    templateUrl: './warm-cache-form.component.html',
    styleUrls: ['./warm-cache-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    MatInputModule,
    MatFormFieldModule,
    ZefFormsModule
]
})
export class WarmCacheFormComponent extends ZefFormBase<WarmCacheFormState> {

  @Input()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  translations: any;

  @Input()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formErrorTranslations: any;

}
